import { Reducer } from "redux";

import { HostsAction, HostsActionTypes, HostsState } from "./types";

const initialState: HostsState = {
  count: 0,
  dataIsLoading: false,
  chartDataIsLoading: false,
  items: [],
  chartItems: [],
  summaryIsLoading: false,
};

const reducer: Reducer<HostsState, HostsAction> = (state = initialState, action) => {
  switch (action.type) {
    case HostsActionTypes.DATA_FETCH_REQUEST: {
      return { ...state, dataIsLoading: true };
    }

    case HostsActionTypes.DATA_FETCH_ERROR: {
      return { ...state, dataIsLoading: false };
    }

    case HostsActionTypes.DATA_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, dataIsLoading: false, items: results };
    }

    case HostsActionTypes.SUMMARY_FETCH_REQUEST: {
      return { ...state, summaryIsLoading: true };
    }

    case HostsActionTypes.SUMMARY_FETCH_ERROR: {
      return { ...state, summary: undefined, summaryIsLoading: false };
    }

    case HostsActionTypes.SUMMARY_FETCH_SUCCESS: {
      return { ...state, summaryIsLoading: false, summary: action.payload };
    }

    case HostsActionTypes.CHART_DATA_FETCH_REQUEST: {
      return { ...state, chartDataIsLoading: true };
    }

    case HostsActionTypes.CHART_DATA_FETCH_ERROR: {
      return { ...state, chartDataIsLoading: false };
    }

    case HostsActionTypes.CHART_DATA_FETCH_SUCCESS: {
      const { items } = action.payload;
      return { ...state, chartDataIsLoading: false, chartItems: items };
    }

    default:
      return state;
  }
};

export default reducer;
